'use client';

import useIsRegistryRoute from '@/hooks/useIsRegistryRoute';
import { AppBar } from '@/primitives';
import Navigation from './Navigation';
import { NAV_HEIGHT } from '@/configs/layout';

export default function DesktopToolbar() {
  const isRegistryRoute = useIsRegistryRoute();

  return (
    <AppBar
      sx={{
        position: 'fixed',
        top: 0,
        border: 'none',
        height: NAV_HEIGHT,
        background: 'white',
        boxShadow: isRegistryRoute ? 'inset 0 0 0 1px #C0C0C0' : 'none',
        zIndex: 1300,

        '@media print': {
          display: 'none',
        },
      }}
    >
      <Navigation />
    </AppBar>
  );
}
